(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire984b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire984b"] = parcelRequire;
}
parcelRequire.register("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = {};
function $0380ce8f1f064ccc$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$0380ce8f1f064ccc$var$mapping[keys[i]] = pairs[keys[i]];
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRequire.register("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $31325aec36f81b55$exports = {};

(parcelRequire("iE7OH")).register(JSON.parse('{"euRbN":"events.3ff24af6.js","7d539":"event-Anniversary.8b56dfa8.svg","lmwTL":"event-Birthday.2e8df6c3.svg","jvkdz":"event-CoffeeChat.ce8a7398.svg","2zUNZ":"event-Default.187cd965.svg","7Bzc1":"event-HappyHour.5f856e27.svg","6WnAH":"event-MagicHour.7e182902.svg","enRJ2":"event-PayDay.681b83cd.svg","bFPWY":"event-TeamLunch.f7e16c72.svg","bJOTj":"map-pin.09f528f9.svg","fNqbU":"map-pin-white.6a01103e.svg","1INq0":"pattern.41e4058b.css","i1vRG":"youshouldnotbehere.22918078.js"}'));



var $4MhCa = parcelRequire("4MhCa");

var $3vtib = parcelRequire("3vtib");
const $e2e85ac8d03bf644$var$STORAGE_ROOT = "fnsz_app_last_";
const $e2e85ac8d03bf644$var$SERVER_URL = "https://funsizeapps.b4a.app/";
const $e2e85ac8d03bf644$var$PEVENTS_ENDPOINT = "getPersonalEvents";
const $e2e85ac8d03bf644$var$CEVENTS_ENDPOINT = "getCompanyEvents";
const $e2e85ac8d03bf644$var$HEVENTS_ENDPOINT = "getHowdyEvents";
const $e2e85ac8d03bf644$var$APP_ID = "rHwkgreMFdjMqUGu9EoemDE4YMomVNLQwIX9Czr9";
const $e2e85ac8d03bf644$var$JAVASCRIPT_KEY = "xdllsMsa2dAhWFuovVzyJTj7OIZmzLMeo5vsEFYv";
const $e2e85ac8d03bf644$var$REST_API_KEY = "fabjEVYWZCwtBWXZ62BF3oAjU7ZzipumKecJidKJ";
$3vtib.initialize($e2e85ac8d03bf644$var$APP_ID, $e2e85ac8d03bf644$var$JAVASCRIPT_KEY);
$3vtib.serverURL = $e2e85ac8d03bf644$var$SERVER_URL;
var $e2e85ac8d03bf644$var$funsizer, $e2e85ac8d03bf644$var$funsizerId, $e2e85ac8d03bf644$var$funsierIdToken, $e2e85ac8d03bf644$var$pEventsLoaded, $e2e85ac8d03bf644$var$cEventsLoaded, $e2e85ac8d03bf644$var$hEventsLoaded, $e2e85ac8d03bf644$var$pEvents, $e2e85ac8d03bf644$var$cEvents, $e2e85ac8d03bf644$var$hEvents, $e2e85ac8d03bf644$var$eventRules;
var $64348d0ad9766d4c$exports = {};


$64348d0ad9766d4c$exports = (parcelRequire("aNJCr")).getBundleURL("euRbN") + (parcelRequire("iE7OH")).resolve("7d539");


var $38b4b93ffccc75e3$exports = {};


$38b4b93ffccc75e3$exports = (parcelRequire("aNJCr")).getBundleURL("euRbN") + (parcelRequire("iE7OH")).resolve("lmwTL");


var $58a7e4e511fd819e$exports = {};


$58a7e4e511fd819e$exports = (parcelRequire("aNJCr")).getBundleURL("euRbN") + (parcelRequire("iE7OH")).resolve("jvkdz");


var $64c37327173f5dbd$exports = {};


$64c37327173f5dbd$exports = (parcelRequire("aNJCr")).getBundleURL("euRbN") + (parcelRequire("iE7OH")).resolve("2zUNZ");


var $23e7b35e2e5b6671$exports = {};


$23e7b35e2e5b6671$exports = (parcelRequire("aNJCr")).getBundleURL("euRbN") + (parcelRequire("iE7OH")).resolve("7Bzc1");


var $c15219be3ad9ba66$exports = {};


$c15219be3ad9ba66$exports = (parcelRequire("aNJCr")).getBundleURL("euRbN") + (parcelRequire("iE7OH")).resolve("6WnAH");


var $e35014f01bbd485b$exports = {};


$e35014f01bbd485b$exports = (parcelRequire("aNJCr")).getBundleURL("euRbN") + (parcelRequire("iE7OH")).resolve("enRJ2");


var $742711f2faec5a93$exports = {};


$742711f2faec5a93$exports = (parcelRequire("aNJCr")).getBundleURL("euRbN") + (parcelRequire("iE7OH")).resolve("bFPWY");


var $f526dd76a85d8f45$exports = {};


$f526dd76a85d8f45$exports = (parcelRequire("aNJCr")).getBundleURL("euRbN") + (parcelRequire("iE7OH")).resolve("bJOTj");


var $d471fcdceb374553$exports = {};


$d471fcdceb374553$exports = (parcelRequire("aNJCr")).getBundleURL("euRbN") + (parcelRequire("iE7OH")).resolve("fNqbU");


const $e2e85ac8d03bf644$var$icons = [
    {
        keyword: "Anniversary",
        image: new URL($64348d0ad9766d4c$exports)
    },
    {
        keyword: "Birthday",
        image: new URL($38b4b93ffccc75e3$exports)
    },
    {
        keyword: "CoffeeChat",
        image: new URL($58a7e4e511fd819e$exports)
    },
    {
        keyword: "Default",
        image: new URL($64c37327173f5dbd$exports)
    },
    {
        keyword: "HappyHour",
        image: new URL($23e7b35e2e5b6671$exports)
    },
    {
        keyword: "MagicHour",
        image: new URL($c15219be3ad9ba66$exports)
    },
    {
        keyword: "PayDay",
        image: new URL($e35014f01bbd485b$exports)
    },
    {
        keyword: "TeamLunch",
        image: new URL($742711f2faec5a93$exports)
    },
    {
        keyword: "MapPin",
        image: new URL($f526dd76a85d8f45$exports)
    },
    {
        keyword: "MapPinWhite",
        image: new URL($d471fcdceb374553$exports)
    }
];
window.addEventListener("load", ()=>{
    gsap.to(document.getElementsByClassName("loader-container")[0], {
        opacity: 1,
        duration: 0.25
    });
    gsap.to(document.getElementsByClassName("loader")[0], {
        scale: 0.5,
        duration: 1,
        ease: "bounce.out",
        repeat: -1,
        yoyo: true
    });
    document.getElementById("btn_logout").addEventListener("click", ()=>{
        $3vtib.User.logOut().then(()=>{
            $e2e85ac8d03bf644$var$initFunsizer();
        });
    });
    $e2e85ac8d03bf644$var$initFunsizer();
    const hiddens = document.querySelector("nav").getElementsByClassName("hidden");
    for(var i = 0; i < hiddens.length; i++)gsap.to(hiddens[i], {
        opacity: 1,
        duration: 0.35,
        delay: 0.2 * i
    });
});
const $e2e85ac8d03bf644$var$initFunsizer = ()=>{
    $e2e85ac8d03bf644$var$funsizer = $3vtib.User.current();
    if ($e2e85ac8d03bf644$var$funsizer) $e2e85ac8d03bf644$var$getFunsizerId().then((id)=>{
        $e2e85ac8d03bf644$var$funsizerId = id;
        var obj = $e2e85ac8d03bf644$var$funsizer.get("authData");
        $e2e85ac8d03bf644$var$funsierIdToken = obj.google.id_token;
        if ($e2e85ac8d03bf644$var$funsizer.get("accessToken")) $e2e85ac8d03bf644$var$listEvents();
        else window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}eventauth.html?redirect=${window.location.pathname}`;
    }).catch(function(e) {
        $e2e85ac8d03bf644$var$handleParseError("Error getting your Funsizer info ", e);
    });
    else window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}login.html?redirect=${window.location.pathname}`;
};
async function $e2e85ac8d03bf644$var$getFunsizerId() {
    const id = localStorage.getObject("funsizer_id");
    if (id == null) {
        const query = new $3vtib.Query($3vtib.User);
        query.equalTo("email", $e2e85ac8d03bf644$var$funsizer.get("email"));
        try {
            const user = await query.find();
            localStorage.setObject("funsizer_id", user[0].id);
            return user[0].id;
        } catch (error) {
            throw error;
        }
    }
    return id;
}
/**
 * Calendar Calls
*/ const $e2e85ac8d03bf644$var$eventTimer = 300000; //every 5 minutes
setInterval(()=>{
    $e2e85ac8d03bf644$var$listEvents();
}, $e2e85ac8d03bf644$var$eventTimer);
const $e2e85ac8d03bf644$var$shouldLoadEventsFromAPI = ()=>{
    const now = Date.now();
    const lastTime = localStorage.getObject(`${$e2e85ac8d03bf644$var$STORAGE_ROOT}event_load`);
    const data = localStorage.getObject(`${$e2e85ac8d03bf644$var$STORAGE_ROOT}event_data`);
    if (lastTime == null || data == null) {
        localStorage.setObject(`${$e2e85ac8d03bf644$var$STORAGE_ROOT}event_load`, now);
        return true;
    }
    return now - lastTime > $e2e85ac8d03bf644$var$eventTimer;
};
const $e2e85ac8d03bf644$var$listEvents = ()=>{
    if (!$e2e85ac8d03bf644$var$shouldLoadEventsFromAPI()) {
        $e2e85ac8d03bf644$var$renderEvents();
        return;
    }
    const query = new $3vtib.Query("Event");
    query.find().then((ers)=>{
        $e2e85ac8d03bf644$var$eventRules = ers;
        $e2e85ac8d03bf644$var$getPersonalEvents();
        $e2e85ac8d03bf644$var$getCompanyEvents();
        $e2e85ac8d03bf644$var$getHowdyEvents();
    }).catch(function(e) {
        $e2e85ac8d03bf644$var$handleParseError("Error when getting events data.", e);
    });
};
const $e2e85ac8d03bf644$var$getPersonalEvents = ()=>{
    $e2e85ac8d03bf644$var$pEventsLoaded = false;
    var endpoint_uri = $e2e85ac8d03bf644$var$SERVER_URL + $e2e85ac8d03bf644$var$PEVENTS_ENDPOINT + "?user_id=" + $e2e85ac8d03bf644$var$funsizerId + "&id_token=" + $e2e85ac8d03bf644$var$funsierIdToken;
    // console.log('uir ' + endpoint_uri);
    const xhr = new XMLHttpRequest();
    xhr.onload = ()=>{
        if (xhr.status == 200) {
            var data = JSON.parse(xhr.responseText);
            const events = data.message;
            // console.log('[[[[personal events]]]')
            // console.log(events)
            $e2e85ac8d03bf644$var$pEventsLoaded = true;
            $e2e85ac8d03bf644$var$pEvents = [];
            $e2e85ac8d03bf644$var$createEventObjects(events, $e2e85ac8d03bf644$var$pEvents);
            $e2e85ac8d03bf644$var$reconcileEvents();
        } else console.log("Ooops! " + xhr.status + ": " + xhr.responseText);
    };
    xhr.open("GET", endpoint_uri, true);
    // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    // xhr.setRequestHeader('X-Parse-Javascript-Key', JAVASCRIPT_KEY);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("X-Parse-REST-API-Key", $e2e85ac8d03bf644$var$REST_API_KEY);
    xhr.setRequestHeader("X-Parse-Application-Id", $e2e85ac8d03bf644$var$APP_ID);
    xhr.withCredentials = true;
    xhr.send();
};
const $e2e85ac8d03bf644$var$getCompanyEvents = ()=>{
    $e2e85ac8d03bf644$var$cEventsLoaded = false;
    var endpoint_uri = $e2e85ac8d03bf644$var$SERVER_URL + $e2e85ac8d03bf644$var$CEVENTS_ENDPOINT + "?user_id=" + $e2e85ac8d03bf644$var$funsizerId + "&id_token=" + $e2e85ac8d03bf644$var$funsierIdToken;
    // console.log('uir ' + endpoint_uri);
    const xhr = new XMLHttpRequest();
    xhr.onload = ()=>{
        if (xhr.status == 200) {
            var data = JSON.parse(xhr.responseText);
            const events = data.message;
            // console.log('[[[[company events]]]')
            // console.log(events)
            $e2e85ac8d03bf644$var$cEvents = [];
            $e2e85ac8d03bf644$var$createEventObjects(events, $e2e85ac8d03bf644$var$cEvents);
            $e2e85ac8d03bf644$var$cEventsLoaded = true;
            $e2e85ac8d03bf644$var$reconcileEvents();
        } else console.log("Ooops! " + xhr.status + ": " + xhr.responseText);
    };
    xhr.open("GET", endpoint_uri, true);
    // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    // xhr.setRequestHeader('X-Parse-Javascript-Key', JAVASCRIPT_KEY);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("X-Parse-REST-API-Key", $e2e85ac8d03bf644$var$REST_API_KEY);
    xhr.setRequestHeader("X-Parse-Application-Id", $e2e85ac8d03bf644$var$APP_ID);
    xhr.withCredentials = true;
    xhr.send();
};
const $e2e85ac8d03bf644$var$getHowdyEvents = ()=>{
    $e2e85ac8d03bf644$var$cEventsLoaded = false;
    var endpoint_uri = $e2e85ac8d03bf644$var$SERVER_URL + $e2e85ac8d03bf644$var$HEVENTS_ENDPOINT + "?user_id=" + $e2e85ac8d03bf644$var$funsizerId + "&id_token=" + $e2e85ac8d03bf644$var$funsierIdToken;
    // console.log('uir ' + endpoint_uri);
    const xhr = new XMLHttpRequest();
    xhr.onload = ()=>{
        if (xhr.status == 200) {
            var data = JSON.parse(xhr.responseText);
            const events = data.message;
            // console.log('[[[[howdy events]]]')
            // console.log(events)
            $e2e85ac8d03bf644$var$hEvents = [];
            $e2e85ac8d03bf644$var$createEventObjects(events, $e2e85ac8d03bf644$var$hEvents);
            $e2e85ac8d03bf644$var$hEventsLoaded = true;
            $e2e85ac8d03bf644$var$reconcileEvents();
        } else console.log("Ooops! " + xhr.status + ": " + xhr.responseText);
    };
    xhr.open("GET", endpoint_uri, true);
    // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    // xhr.setRequestHeader('X-Parse-Javascript-Key', JAVASCRIPT_KEY);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("X-Parse-REST-API-Key", $e2e85ac8d03bf644$var$REST_API_KEY);
    xhr.setRequestHeader("X-Parse-Application-Id", $e2e85ac8d03bf644$var$APP_ID);
    xhr.withCredentials = true;
    xhr.send();
};
const $e2e85ac8d03bf644$var$WEEK_LENGTH = 604800000;
const $e2e85ac8d03bf644$var$createEventObjects = (a, dest)=>{
    //TODO: Do this correctly by adding an "exact match" option to the event object
    //KLUDGE: If Keyword begins with '*' then that means exact match. Parse those first
    var exacts = $e2e85ac8d03bf644$var$eventRules.filter((rule)=>rule.get("Keyword").includes("*"));
    var softs = $e2e85ac8d03bf644$var$eventRules.filter((rule)=>!rule.get("Keyword").includes("*"));
    var filtered = a.filter((item)=>{
        // console.log(item.summary)
        var matches = false;
        for(var i = 0; i < exacts.length; i++){
            const check = exacts[i].get("Keyword").replace("*", "");
            matches = item.summary == check;
            if (matches) {
                const excluded = exacts[i].get("ExcludedWords");
                if (excluded) {
                    const excl = excluded.split(",");
                    for(var j = 0; j < excl.length; j++)if (matches && item.summary.includes(excl[j])) matches = false;
                }
            }
            if (matches) {
                //TODO: This is another total kludge because I know we just have anniversaries to contend with atm...need proper categories in the DB
                item.category = exacts[i].get("Keyword").includes("HH") ? "Happy Hour" : "Anniversary";
                // item.category = exacts[i].get('Keyword');
                item.imageUrl = exacts[i].get("Image").url();
                item.countdown = exacts[i].get("Countdown");
                item.categoryIconKeyword = item.category.replace(" ", "");
                break;
            }
        }
        if (!matches) for(var i = 0; i < softs.length; i++){
            matches = item.summary.includes(softs[i].get("Keyword"));
            if (matches) {
                const excluded = softs[i].get("ExcludedWords");
                if (excluded) {
                    const excl = excluded.split(",");
                    for(var j = 0; j < excl.length; j++)if (matches && item.summary.includes(excl[j])) matches = false;
                }
            }
            if (matches) {
                item.category = softs[i].get("Keyword");
                item.imageUrl = softs[i].get("Image").url();
                item.countdown = softs[i].get("Countdown");
                item.categoryIconKeyword = item.category.replace(" ", "");
                break;
            }
        }
        return matches;
    });
    if (filtered.length == 0) return;
    const nowD = new Date();
    nowD.setDate(nowD.getDate() - (nowD.getDay() - 1)); // Setting date to last Monday
    nowD.setHours(0, 0, 0, 0); // Setting Hour to 00:00:00:00
    filtered.forEach((i)=>{
        var obj = new Object();
        obj.category = i.category;
        obj.categoryIconKeyword = i.categoryIconKeyword;
        obj.countdown = i.countdown;
        obj.imageUrl = i.imageUrl;
        obj.title = i.summary;
        obj.allDay = i.start.date != null;
        obj.location = "";
        if (i.location) {
            const locs = i.location.split(",");
            obj.location = locs[0];
        }
        var startD = new Date(i.start.dateTime);
        if (obj.allDay) {
            const tempD = new Date(i.start.date);
            startD = new Date(tempD.getFullYear(), tempD.getMonth(), tempD.getDate() + 1);
        }
        // console.log(startD)
        obj.trueDate = startD;
        const thisWeek = nowD.getTime() <= startD.getTime() && startD.getTime() < nowD.getTime() + $e2e85ac8d03bf644$var$WEEK_LENGTH;
        obj.time = "";
        if (obj.allDay) {
            const tempEndD = new Date(i.end.date);
            const endD = new Date(tempEndD.getFullYear(), tempEndD.getMonth(), tempEndD.getDate());
            //if end is not start, show duration 
            var addendum = "";
            if (startD.getTime() != endD.getTime()) {
                if (thisWeek) addendum = ` - ${endD.toLocaleString("en-US", {
                    weekday: "short"
                })}, ${endD.toLocaleString("en-US", {
                    month: "short"
                })} ${endD.getDate()} ${addendum}`;
                else addendum = ` - ${endD.toLocaleString("en-US", {
                    month: "short"
                })} ${endD.getDate()} ${addendum}`;
            }
            //if this week show day and date otherwise just date
            if (thisWeek) obj.date = `${startD.toLocaleString("en-US", {
                weekday: "short"
            })}, ${startD.toLocaleString("en-US", {
                month: "short"
            })} ${startD.getDate()} ${addendum}`;
            else obj.date = `${startD.toLocaleString("en-US", {
                month: "short"
            })} ${startD.getDate()} ${addendum}`;
        } else {
            //if this week show day otherwise date 
            if (thisWeek) obj.date = `${startD.toLocaleString("en-US", {
                weekday: "short"
            })}`;
            else obj.date = `${startD.toLocaleString("en-US", {
                month: "short"
            })} ${startD.getDate()}`;
            var startH = startD.getHours();
            startH = startH > 12 ? startH - 12 : startH;
            var startM = startD.getMinutes();
            startM = startM < 10 ? ":0" + startM : ":" + startM;
            startM = startD.getHours() >= 12 ? "pm" : "am";
            const endD = new Date(i.end.dateTime);
            var endH = endD.getHours();
            endH = endH > 12 ? endH - 12 : endH;
            var endM = endD.getMinutes();
            endM = endM < 10 ? ":0" + endM : ":" + endM;
            endM = endD.getHours() >= 12 ? "pm" : "am";
            obj.time = `, ${startH}${startM}-${endH}${endM}`;
        }
        if (obj.countdown) {
            const n = new Date();
            const date1 = Date.UTC(startD.getFullYear(), startD.getMonth(), startD.getDate());
            const date2 = Date.UTC(n.getFullYear(), n.getMonth(), n.getDate());
            var ms = Math.abs(date1 - date2);
            obj.daysRemaining = Math.floor(ms / 1000 / 60 / 60 / 24);
            obj.isDayOfEvent = obj.daysRemaining == 0;
            obj.isReallyFarOff = obj.daysRemaining > 99;
            const dif = obj.daysRemaining.toString().split("");
            if (dif.length == 1) {
                obj.firstNum = 0;
                obj.secondNum = dif[0];
            } else {
                obj.firstNum = dif[0];
                obj.secondNum = dif[1];
            }
        }
        dest.push(obj);
    });
};
const $e2e85ac8d03bf644$var$reconcileEvents = ()=>{
    if (!$e2e85ac8d03bf644$var$pEventsLoaded || !$e2e85ac8d03bf644$var$cEventsLoaded || !$e2e85ac8d03bf644$var$hEventsLoaded) return;
    var all = $e2e85ac8d03bf644$var$pEvents;
    all = all.concat($e2e85ac8d03bf644$var$cEvents);
    all = all.concat($e2e85ac8d03bf644$var$hEvents);
    all = [
        ...new Map(all.map((m)=>[
                m.title + m.date,
                m
            ])).values()
    ]; //get rid of dupes
    all.sort((a, b)=>{
        return a.trueDate - b.trueDate;
    }); //sort by date
    //ensure there is only 1 countdown event, and make it the second item in the list
    var hasCountDown = false;
    var countDownIndex = -1;
    for(var i = 0; i < all.length; i++)if (all[i].countdown && !hasCountDown) {
        countDownIndex = i;
        hasCountDown = true;
    } else all[i].countdown = false;
    if (countDownIndex > 1) {
        const obj = all.splice(countDownIndex, 1)[0];
        all.splice(1, 0, obj);
    }
    if (all.length > 15) all = all.slice(0, 15);
    if (all.length > 0) {
        const now = Date.now();
        localStorage.setObject(`${$e2e85ac8d03bf644$var$STORAGE_ROOT}event_load`, now);
        localStorage.setObject(`${$e2e85ac8d03bf644$var$STORAGE_ROOT}event_data`, all);
    }
    $e2e85ac8d03bf644$var$renderEvents();
};
const $e2e85ac8d03bf644$var$renderEvents = ()=>{
    gsap.to(document.getElementsByClassName("loader-container")[0], {
        opacity: 0,
        duration: 0.25
    });
    const events = localStorage.getObject(`${$e2e85ac8d03bf644$var$STORAGE_ROOT}event_data`);
    const eventContainer = document.getElementById("events");
    gsap.to(eventContainer, {
        opacity: 1,
        duration: 0.5,
        delay: 0.25
    });
    eventContainer.innerHTML = "";
    if (!events || events.length == 0) //TODO: Empty state
    return;
    for(var i = 0; i < events.length; i++){
        const event = events[i];
        if (event.countdown == true) {
            const countdownContainer = document.createElement("section");
            const countdownDetails = document.createElement("div");
            const countdown3js = document.createElement("div");
            const countdownContentContainer = document.createElement("div");
            const countdownTitle = document.createElement("h2");
            const countdownMetadataContainer = document.createElement("div");
            const countdownMetadataTime = document.createElement("p");
            const countdownLocationContainer = document.createElement("div");
            const countdownLocationImage = document.createElement("img");
            const countdownLocation = document.createElement("p");
            const countdownImage = document.createElement("div");
            countdownContainer.classList.add("card", "countdown");
            countdownDetails.classList.add("card-details");
            countdown3js.classList.add("big-number");
            countdownContentContainer.classList.add("countdown-info");
            countdownMetadataContainer.classList.add("metadata");
            countdownLocationContainer.classList.add("wrap");
            countdownImage.classList.add("card-image");
            countdownTitle.innerHTML = event.isDayOfEvent ? event.title + " IS HERE!" : event.isReallyFarOff ? `${event.daysRemaining} DAYS UNTIL ` + event.title : "DAYS UNTIL " + event.title;
            countdownMetadataTime.innerHTML = event.date + event.time;
            countdownLocationContainer.style.display = event.location == "" ? "none" : "auto";
            countdownLocationImage.src = $e2e85ac8d03bf644$var$icons.filter((i)=>i.keyword == "MapPinWhite")[0].image;
            countdownLocation.innerHTML = event.location;
            countdownImage.style.backgroundImage = "url(" + event.imageUrl + ")";
            eventContainer.append(countdownContainer);
            countdownContainer.append(countdownDetails, countdownImage);
            countdownDetails.append(countdown3js, countdownContentContainer);
            countdownContentContainer.append(countdownTitle, countdownMetadataContainer);
            countdownMetadataContainer.append(countdownMetadataTime, countdownLocationContainer);
            countdownLocationContainer.append(countdownLocationImage, countdownLocation);
            $e2e85ac8d03bf644$var$setUpFx(countdown3js, event.firstNum, event.secondNum, event.isDayOfEvent, event.isReallyFarOff);
        } else {
            const cardContainer = document.createElement("div");
            const cardDetails = document.createElement("div");
            const cardCategoryContainer = document.createElement("div");
            const cardCategoryImg = document.createElement("img");
            const cardCategory = document.createElement("p");
            const cardContentContainer = document.createElement("div");
            const cardContentTitle = document.createElement("h2");
            const cardMetadataContainer = document.createElement("div");
            const cardMetadataTime = document.createElement("p");
            const cardLocationContainer = document.createElement("div");
            const cardLocationImage = document.createElement("img");
            const cardLocation = document.createElement("p");
            const cardImage = document.createElement("div");
            cardContainer.classList.add("card", "event");
            cardDetails.classList.add("card-details");
            cardCategoryContainer.classList.add("wrap");
            cardMetadataContainer.classList.add("metadata");
            cardLocationContainer.classList.add("wrap");
            cardImage.classList.add("card-image");
            const icon = $e2e85ac8d03bf644$var$icons.filter((i)=>i.keyword == event.categoryIconKeyword);
            if (icon.length > 0) cardCategoryImg.src = icon[0].image;
            cardCategory.innerHTML = event.category;
            cardContentTitle.innerHTML = event.title;
            cardMetadataTime.innerHTML = event.date + event.time;
            cardLocationContainer.style.display = event.location == "" ? "none" : "auto";
            cardLocationImage.src = $e2e85ac8d03bf644$var$icons.filter((i)=>i.keyword == "MapPin")[0].image;
            cardLocation.innerHTML = event.location;
            cardImage.style.backgroundImage = "url(" + event.imageUrl + ")";
            eventContainer.append(cardContainer);
            cardContainer.append(cardDetails, cardImage);
            cardDetails.append(cardCategoryContainer, cardContentContainer);
            cardCategoryContainer.append(cardCategoryImg, cardCategory);
            cardContentContainer.append(cardContentTitle, cardMetadataContainer);
            cardMetadataContainer.append(cardMetadataTime, cardLocationContainer);
            cardLocationContainer.append(cardLocationImage, cardLocation);
        }
    }
};
const $e2e85ac8d03bf644$var$setUpFx = (parent, num1, num2, isDayOfEvent, isReallyFarOff)=>{
    const webgl = document.createElement("canvas");
    webgl.id = "webgl";
    webgl.classList.add("webgl-card");
    parent.append(webgl);
    if (isDayOfEvent) (0, $4MhCa.initializeFX)(webgl, null, null, false, "random", true, false);
    else if (isReallyFarOff) (0, $4MhCa.initializeFX)(webgl, null, null, false, "random", false, true);
    else (0, $4MhCa.initializeFX)(webgl, parseInt(num1), parseInt(num2), false, "random", false, false);
};
function $e2e85ac8d03bf644$var$handleParseError(msg, err) {
    switch(err.code){
        case $3vtib.Error.INVALID_SESSION_TOKEN:
            alert("Invalid session token.");
            $3vtib.User.logOut();
            window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}login.html?redirect=${window.location.pathname}`;
            break;
        default:
            console.log(`${msg} : ${err.code} - ${err.message}`);
    }
}
Storage.prototype.setObject = function(key, value) {
    this.setItem(key, JSON.stringify(value));
};
Storage.prototype.getObject = function(key) {
    var value = this.getItem(key);
    return value && JSON.parse(value);
};

})();
//# sourceMappingURL=events.3ff24af6.js.map
